import React from "react";

import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useAppState } from "../../../../../context/StateContext";
import { Color } from "../../../../Form/Button";
import { GroupedButtons } from "../../../../Generic/GroupedButtons";
import { MenuActionsButtonItems } from "../../../../Generic/MenuActionsButton";
import { BookingTabs } from "../../../util";
import useStyles from "./styles";
import { isShowAction } from "Util/permissions";

interface BookingActionsButtonsProps {
  leftPanelSelected: string;
  handleSaveDocuments: () => void;
  validateAndSaveBooking: () => void;
  menuItems: MenuActionsButtonItems[];
  onCancel: () => void;
  loading: boolean;
  viewOnly: boolean;
  onSaveAndBook: () => void;
  isWarehouseUser: boolean;
  bookingAlreadySubmitted: boolean;
  bookingId?: number;
  permission?: {
    edit: boolean,
    create: boolean,
  }
}

const BookingActionsButtons = (props: BookingActionsButtonsProps) => {
  const {
    leftPanelSelected,
    handleSaveDocuments,
    validateAndSaveBooking,
    menuItems,
    onCancel,
    loading,
    viewOnly,
    onSaveAndBook,
    isWarehouseUser,
    bookingId,
    bookingAlreadySubmitted,
    permission,
  } = props;
  const classes = useStyles();
  const { t: translate } = useTranslation();
  const { currentUser, isSupplierPortal, isFMVersion } = useAppState();

  const save = () => {
    if (leftPanelSelected === BookingTabs.DOCUMENTS) {
      return handleSaveDocuments;
    }
    if (!isWarehouseUser) {
      return () => validateAndSaveBooking();
    }

    return undefined;
  };

  const handleButtonsByPermission = () => {
    let buttons: any[] = [{
      name: "cancel",
      action: onCancel,
      disabled: loading,
      variant: "text",
      customColor: Color.CANCEL,
      text: translate("cancel"),
    }];

    if (
      (!bookingId && permission && isShowAction(currentUser, permission?.create)) ||
      (bookingId && permission && isShowAction(currentUser, permission?.edit))
    ) {
      buttons?.push({
        name: "save",
        action: save(),
        disabled:
          leftPanelSelected === BookingTabs.DOCUMENTS
            ? false
            : viewOnly || (bookingAlreadySubmitted && !isFMVersion),
        loading,
        className: isFMVersion ? undefined : classes.saveAndBook,
        customColor: Color.SUCCESS,
        text: !bookingId ? translate("create") : translate("save"),
      },
      {
        name: "saveAndBook",
        text: !bookingId ? translate("createAndBook") : translate("saveAndBook"),
        action: isSupplierPortal && !viewOnly ? onSaveAndBook : undefined,
        loading,
        customColor: Color.SUCCESS,
      })
    }

    return buttons;
  }

  return (
    <Box
      className={classes.buttons}
      display="flex"
      flexDirection={"row"}
      justifyContent={"space-between"}
    >
      <Box
        display="flex"
        flexDirection={"row"}
        justifyContent={"flex-start"}
        className={classes.buttons}
      >
        <GroupedButtons
          buttons={[
            {
              name: "menuItems",
              menuItems: isFMVersion ? menuItems : undefined,
              disabled: viewOnly,
              loading,
            },
          ]}
        ></GroupedButtons>
      </Box>
      <Box
        display="flex"
        flexDirection={"row"}
        justifyContent={"flex-end"}
        className={classes.buttons}
      >
        <GroupedButtons
          buttons={handleButtonsByPermission()}
        ></GroupedButtons>
      </Box>
    </Box>
  );
};

export default BookingActionsButtons;
